export default __webpack_public_path__ + "static/media/history.48f26ec2.png";